import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useMyBatchEnrollment } from 'features/schools/hooks/useSchools';
import {
  resolveBhriguContextFromPath,
  type BhriguContextStack,
} from 'shared/lib/bhriguContextStack';

export function useBhriguContextStack(): {
  stack: BhriguContextStack;
  pageKey: string | null;
  pageTitle: string;
} {
  const { pathname, search } = useLocation();
  const resolved = useMemo(() => resolveBhriguContextFromPath(pathname, search), [pathname, search]);
  const batchId = resolved.stack.batchId ?? '';
  const { data: enrollment } = useMyBatchEnrollment(batchId);

  const stack = useMemo((): BhriguContextStack => {
    if (!batchId || !enrollment) return resolved.stack;
    return {
      ...resolved.stack,
      batchId,
      enrollmentId: enrollment.enrollmentId,
      institutionId: enrollment.institutionId,
      courseId: enrollment.courseId ?? resolved.stack.courseId,
      schoolSlug: enrollment.schoolSlug ?? resolved.stack.schoolSlug,
    };
  }, [resolved.stack, batchId, enrollment]);

  return {
    stack,
    pageKey: resolved.pageKey,
    pageTitle: resolved.pageTitle,
  };
}
